<template>
  <div class="detection-center-home">
    <section class="hero">
      <div class="hero-inner">
        <h2>检测服务中心</h2>
        <div class="subtitle">面向水泵及产业链的公共检测服务平台 · 流量 / 扬程 / 功率 / 转速 / 电流电压 / 绝缘密封全性能检测</div>
        <a class="hero-btn" href="javascript:;" @click="goEntrust">检测任务委托</a>
      </div>
    </section>

    <div class="main-wrap">
      <!-- 检测中心介绍 -->
      <div class="card">
        <div class="intro">
          <div
            class="intro-img"
            :class="{ 'has-banner': !!bannerUrl }"
            :style="bannerUrl ? { backgroundImage: `url(${bannerUrl})` } : null"
          >
            <div class="machine">{{ bannerTitle || '水泵综合性能试验台 · 国家认证实验室' }}</div>
          </div>
          <div class="intro-text">
            <div class="sec-title"><span class="bar"></span>检测中心介绍</div>
            <p>面向水泵及相关产业链提供具备行业影响力的公共检测服务平台。检测水泵流量、扬程、功率、转速、电流、电压、电机线圈绝缘密封等性能参数，为水泵行业提供新技术、新产品、新工艺的支持服务。</p>
            <p>打造盐湖区水泵政府认证码，建立申请、检测、认证、赋码、追溯的一整套管理体系，增强盐湖区水泵的品牌影响力，推动盐湖区水泵产业高质量发展。</p>
            <div class="feature-list">
              <div class="feature-item"><span class="ico">✓</span>CMA 资质认证检测报告</div>
              <div class="feature-item"><span class="ico">✓</span>18 档功率段全覆盖试验台</div>
              <div class="feature-item"><span class="ico">✓</span>在线委托 · 进度实时可查</div>
              <div class="feature-item"><span class="ico">✓</span>检测认证赋码追溯一体化</div>
            </div>
            <a class="btn-apply" href="javascript:;" @click="goEntrust">立即发起检测任务委托 →</a>
          </div>
        </div>
      </div>

      <!-- 服务流程 -->
      <div class="card">
        <div class="sec-title"><span class="bar"></span>服务流程</div>
        <div class="flow">
          <div class="flow-step">
            <div class="ico">1</div>
            <div class="name">提交委托</div>
            <div class="desc">在线填写委托单</div>
          </div>
          <div class="flow-step">
            <div class="ico">2</div>
            <div class="name">确认支付</div>
            <div class="desc">在线支付检测费</div>
          </div>
          <div class="flow-step">
            <div class="ico">3</div>
            <div class="name">送样检测</div>
            <div class="desc">寄送样品实验室检测</div>
          </div>
          <div class="flow-step">
            <div class="ico">4</div>
            <div class="name">报告下载</div>
            <div class="desc">在线获取检测报告</div>
          </div>
        </div>
      </div>

      <!-- 收费标准 -->
      <div class="card">
        <div class="sec-title">
          <span class="bar"></span>水泵实验收费标准
          <span class="unit-tip">金额单位：台次/元</span>
        </div>
        <div class="table-wrap">
          <el-table :data="feeList" border style="width:100%">
            <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
            <el-table-column prop="powerRangeLabel" label="功率（kW）" align="center"></el-table-column>
            <el-table-column prop="perfPrice" label="性能实验" align="center"></el-table-column>
            <el-table-column prop="cmaPrice" label="CMA测试报告" align="center"></el-table-column>
          </el-table>
        </div>
        <div class="price-note">注：以上收费标准由检测中心统一维护，实际检测费用以委托单结算为准；如需大功率定制试验，请联系客服。</div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInspectionFeeList, getDictionaryItem } from '@/utils/interface.js';

export default {
  name: 'detectionCenterHome',
  data() {
    return {
      feeList: [],
      bannerUrl: '',
      bannerTitle: ''
    };
  },
  mounted() {
    this.loadFee();
    this.loadBanner();
  },
  methods: {
    loadFee() {
      getInspectionFeeList().then(res => {
        this.feeList = Array.isArray(res) ? res : (res && res.data) || [];
      }).catch(() => {
        this.feeList = [];
      });
    },
    loadBanner() {
      getDictionaryItem({ groupCode: 'CHECK_BANNER' }).then(res => {
        const list = Array.isArray(res) ? res : (res && res.data) || [];
        if (list.length > 0) {
          this.bannerUrl = list[0].value || '';
          this.bannerTitle = list[0].name || list[0].remarks || '';
        }
      }).catch(() => {
        this.bannerUrl = '';
      });
    },
    goEntrust() {
      this.$router.push({ name: 'detectionEntrust' });
    }
  }
};
</script>

<style lang="less" scoped>
.detection-center-home {
  --teal-grad: linear-gradient(90deg, #3AC7B5 0%, #1E9C8E 100%);
  background: #F0F4F8;
  padding-bottom: 40px;
  color: #333;
  font-size: 14px;
}
.hero {
  height: 260px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, rgba(30,120,210,0.85) 0%, rgba(46,150,220,0.78) 100%),
              linear-gradient(135deg, #4A90D9 0%, #2E6FB7 100%);
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      repeating-linear-gradient(115deg, rgba(255,255,255,0.06) 0 2px, transparent 2px 60px),
      radial-gradient(ellipse 700px 320px at 80% 15%, rgba(255,255,255,0.20), transparent),
      radial-gradient(ellipse 560px 280px at 12% 95%, rgba(255,255,255,0.12), transparent);
  }
  .hero-inner {
    position: relative;
    z-index: 1;
    text-align: center;
    color: #fff;
    padding-top: 78px;
    h2 {
      font-size: 38px;
      font-weight: 700;
      letter-spacing: 8px;
      margin-bottom: 16px;
      text-shadow: 0 2px 10px rgba(0,0,0,0.15);
    }
    .subtitle {
      font-size: 16px;
      letter-spacing: 2px;
      opacity: .95;
      margin-bottom: 30px;
    }
  }
}
.hero-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--teal-grad);
  color: #fff;
  border: none;
  padding: 13px 46px;
  border-radius: 26px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0,0,0,0.2);
  transition: all .25s;
  text-decoration: none;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 26px rgba(0,0,0,0.28);
    color: #fff;
  }
}
.main-wrap {
  max-width: 1200px;
  margin: -70px auto 60px;
  padding: 0 20px;
  position: relative;
  z-index: 10;
}
.card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 6px 30px rgba(21, 80, 145, 0.12);
  padding: 40px 48px;
  margin-bottom: 24px;
}
.intro {
  display: flex;
  gap: 36px;
  align-items: stretch;
}
.intro-img {
  width: 42%;
  min-height: 300px;
  border-radius: 10px;
  position: relative;
  overflow: hidden;
  background: linear-gradient(135deg, #2E6FB7 0%, #4A90D9 55%, #6BB8E8 100%) center / cover no-repeat;
  display: flex;
  align-items: flex-end;
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 300px 160px at 70% 25%, rgba(255,255,255,0.25), transparent),
      repeating-linear-gradient(90deg, rgba(255,255,255,0.07) 0 3px, transparent 3px 46px);
    pointer-events: none;
  }
  &.has-banner::before {
    background: linear-gradient(0deg, rgba(10,50,90,0.35), transparent 55%);
  }
  .machine {
    position: relative;
    width: 100%;
    padding: 22px;
    background: linear-gradient(0deg, rgba(10,50,90,0.45), transparent);
    color: #fff;
    font-size: 13px;
    letter-spacing: 1px;
  }
}
.intro-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  p {
    color: #666;
    line-height: 2;
    font-size: 14px;
    margin-bottom: 14px;
    text-align: justify;
  }
}
.sec-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 18px;
  .bar {
    width: 4px;
    height: 18px;
    border-radius: 2px;
    background: var(--teal-grad);
  }
  .unit-tip {
    font-size: 13px;
    color: #999;
    font-weight: 400;
    margin-left: 8px;
  }
}
.feature-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin: 6px 0 22px;
}
.feature-item {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #F2FBFA;
  border: 1px solid #D9F2EE;
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  color: #0F766E;
  .ico {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    flex-shrink: 0;
    background: var(--teal-grad);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
  }
}
.btn-apply {
  align-self: flex-start;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: var(--teal-grad);
  color: #fff;
  border: none;
  padding: 13px 44px;
  border-radius: 24px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(30,156,142,0.35);
  transition: all .25s;
  text-decoration: none;
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 9px 22px rgba(30,156,142,0.45);
    color: #fff;
  }
}
.flow {
  display: flex;
  justify-content: space-between;
  max-width: 980px;
  margin: 10px auto 0;
  position: relative;
  &::before {
    content: "";
    position: absolute;
    top: 22px;
    left: 8%;
    right: 8%;
    height: 2px;
    background: #E5E7EB;
  }
}
.flow-step {
  position: relative;
  z-index: 1;
  text-align: center;
  flex: 1;
  .ico {
    width: 46px;
    height: 46px;
    margin: 0 auto 10px;
    border-radius: 50%;
    background: var(--teal-grad);
    color: #fff;
    font-size: 18px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 12px rgba(30,156,142,0.3);
  }
  .name { font-size: 14px; font-weight: 600; color: #333; }
  .desc { font-size: 12px; color: #999; margin-top: 3px; }
}
.table-wrap {
  overflow-x: auto;
  border-radius: 8px;
  max-height: 520px;
  overflow-y: auto;
}
.price-note {
  font-size: 12px;
  color: #999;
  margin-top: 12px;
}
@media (max-width: 900px) {
  .intro { flex-direction: column; }
  .intro-img { width: 100%; }
  .card { padding: 24px 20px; }
  .feature-list { grid-template-columns: 1fr; }
  .flow { flex-wrap: wrap; gap: 16px; }
  .flow::before { display: none; }
}
</style>



// WEBPACK FOOTER //
// src/components/detectionEntrust/home.vue